import * as React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import { useState } from "react";
import "./CommonDashboard.css";
import { useSelector, useDispatch } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import { CssBaseline } from "@material-ui/core";
import TableStatus from "./TableStatus";


const theme = createMuiTheme({
  spacing: 5,
});



export const Site = ({
  selectedOption,
  errors, isLoading,
  sites: rows,
  setSites: setRows,
  setSelectedSiteForEdit,
  setSelectedSiteForDelete,
  selectedSiteForDelete,
}) => {
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();
  const api = localStorage.getItem("api");
  const headers = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);


  const [deleteConfirmationText, setDeleteConfirmationText] = useState("");



  const handleCloseDeleteDialog = () => {
    setDeleteConfirmationText("");
    setSelectedSiteForDelete({});
  };

  const handleConfirmDelete = () => {
    if (
      deleteConfirmationText.trim().toUpperCase() !== "DELETE" ||
      !selectedSiteForDelete?.id
    ) {
      return;
    }

    setLoading(true);

    const requestBody = {
      path: "site",
      query: { id: `${selectedSiteForDelete.id}` },
      emmsId: selectedOption,
      body: {},
      requestType: "DELETE",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .post(api + `/auth/piggyback`, requestBody, headers)
      .then(() => {
        setRows((prevRows) => {
          const updatedRows = prevRows?.filter(
            (row) => row.id !== selectedSiteForDelete.id
          );
          return updatedRows;
        });
        setDeleteConfirmationText("");
        setSelectedSiteForDelete({});
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancelDelete = () => {
    setDeleteConfirmationText("");
    setSelectedSiteForDelete({});
  };

 const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "location",
      headerName: "Location",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      minWidth: 180,
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      flex: 1,
      minWidth: 180,
    },
    {
      field: "edit",
      headerName: "Edit",
      flex: 0.8,
      sortable: false,
      minWidth: 120,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="primary"
          startIcon={<EditIcon />}
          onClick={() => setSelectedSiteForEdit(params.row)}
        >
          Edit
        </Button>
      ),
    },
    {
      field: "delete",
      headerName: "Delete",
      flex: 0.9,
      sortable: false,
      minWidth: 130,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={() => {
            setDeleteConfirmationText("");
            setSelectedSiteForDelete(params.row);
          }}
          disabled
        >
          {loading && selectedSiteForDelete?.id === params.row.id
            ? "Deleting..."
            : "Delete"}
        </Button>
      ),
    },
  ];



  return (
    <>
      {rows?.length > 0 && errors === false ? (
        <CssBaseline>
          <ThemeProvider theme={theme}>
            <div
              className="emms-data-grid-container"
              style={{ padding: "2.5% 10%", overflowX: "auto" }}
            >
              <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                checkboxSelection
                disableRowSelectionOnClick
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
              />
            </div>

            <Dialog
              open={Boolean(selectedSiteForDelete?.id)}
              onClose={handleCloseDeleteDialog}
              maxWidth="sm"
              fullWidth
            >
              <DialogTitle>Delete Site</DialogTitle>
              <DialogContent>
                <DialogContentText sx={{ mb: 2 }}>
                  Are you sure you want to delete {selectedSiteForDelete?.name}
                  <strong>{selectedSiteForDelete?.email || ""}</strong>?
                </DialogContentText>

                <DialogContentText sx={{ mb: 2, color: "error.main" }}>
                  Warning: This action cannot be undone.
                </DialogContentText>



                <TextField
                  autoFocus
                  fullWidth
                  size="small"
                  label="Type DELETE to confirm"
                  value={deleteConfirmationText}
                  onChange={(e) => setDeleteConfirmationText(e.target.value)}
                />
              </DialogContent>

              <DialogActions sx={{ padding: "16px 24px 20px" }}>
                <Button
                  variant="outlined"
                  onClick={handleCancelDelete}
                  disabled={loading}
                  color="error"
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
  
                  onClick={handleConfirmDelete}
                  disabled={
                    loading ||
                    deleteConfirmationText.trim().toUpperCase() !== "DELETE"
                  }
    
                >
                  {loading ? "Deleting..." : "Confirm"}
                </Button>
              </DialogActions>
            </Dialog>
          </ThemeProvider>
        </CssBaseline>
      ) : (
        <TableStatus loading={isLoading} errors={errors} />
      )}
    </>
  );
};